import styled from '@emotion/styled'
import Icon from 'shared/library/atoms/Icon'
import Flex from 'shared/library/atoms/Flex'
import { css } from '@emotion/react'

type RatingProps = {
  score: number
  maxScore: number
  size?: number
  starColor?: 'gold'
}

const Rating = ({ score, maxScore, size, starColor }: RatingProps) => {
  const iconSize = size || 12
  const foregroundWidth = score * iconSize

  return (
    <RatingContainer>
      <BackgroundIcons>
        {Array.from({ length: maxScore }, (_, index) => (
          <Icon key={index} name="star-outline" size={iconSize} />
        ))}
      </BackgroundIcons>
      <ForegroundIcons width={foregroundWidth}>
        {Array.from({ length: Math.ceil(score) }, (_, index) => (
          <Icon
            key={index}
            name="star"
            size={iconSize}
            color={starColor ? starColor : undefined}
          />
        ))}
      </ForegroundIcons>
    </RatingContainer>
  )
}

export default Rating

const RatingContainer = styled(Flex)(() =>
  css({
    position: 'relative'
  })
)

const BackgroundIcons = styled(Flex)(() =>
  css({
    position: 'relative',
    top: 0,
    left: 0,
    zIndex: 0,
    margin: '1px'
  })
)

const ForegroundIcons = styled(Flex)(({ width }) =>
  css({
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
    margin: '1px',
    overflowX: 'hidden',
    width: `${width}px`
  })
)
